import { render, staticRenderFns } from "./Complemento.vue?vue&type=template&id=024a2473&"
import script from "./Complemento.vue?vue&type=script&lang=js&"
export * from "./Complemento.vue?vue&type=script&lang=js&"
import style0 from "./Complemento.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports